import React, { useState } from "react";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";


const RequestTopUpGateway = () => {
  const [amount, setAmount] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  const initiatePayment = async () => {
    try {
      const transactionId = "TXN" + new Date().getTime();
      const callbackUrl = "https://yourwebsite.com/payment-success";
  
      const requestData = {
        amount,
        mobileNumber,
        transactionId,
        callbackUrl,
      };
  
      console.log("🔹 Sending Payment Request:", requestData);
  
      const response = await axios.post(`${baseurl}phonepay`, requestData);
  
      console.log("✅ Payment Response:", response.data);
  
      if (response.data.success) {
        const paymentUrl = response.data.paymentUrl;
  
        // Open payment link in the same page
        window.location.href = paymentUrl;
      } else {
        alert("Payment initiation failed.");
      }
    } catch (error) {
      console.error("❌ Error in Payment:", error?.response?.data || error);
      alert("Payment failed.");
    }
  };
  
  

  return (
    <div className="border rounded p-3 text-start">
      {/* <h2>Pay with PhonePe</h2> */}
      <div className="mb-3">
      <label className="form-label">Enter Amount (₹):</label>
      <input
        type="number" className="form-control"
        placeholder="Enter Amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
      />
      </div>
      <div className="mb-3">
      <label className="form-label">Enter Phone Number:</label>
      <input
        type="text" className="form-control"
        placeholder="Enter Mobile Number"
        value={mobileNumber}
        onChange={(e) => setMobileNumber(e.target.value)}
      />
      </div>
      
      
      <button onClick={initiatePayment} className="btn btn-primary ">Pay Now</button>
    </div>
  );
};

export default RequestTopUpGateway;
